import { Link, Typography } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ORIGIN } from '../constants/Router';
import {
  RIDER_APP_NEW_LOG_IN,
  usePublicFeatureFlags,
} from '../hooks/usePublicFeatureFlags';

const textConfig = {
  variant: 'body2',
};

export const CreateAccountLink = props => {
  const featureFlags = usePublicFeatureFlags();

  // Hidden while flags load so the link doesn't flash before being removed.
  if (!featureFlags || featureFlags.includes(RIDER_APP_NEW_LOG_IN)) {
    return null;
  }

  return (
    <Typography {...textConfig} {...props}>
      Don't have an account?{' '}
      <Link
        component={RouterLink}
        to={{
          pathname: `/welcome`,
          search: '?origin=' + ORIGIN.CREATE_ACCOUNT_LINK,
        }}
        {...textConfig}
      >
        Create new
      </Link>
    </Typography>
  );
};

CreateAccountLink.propTypes = {
  'data-testid': PropTypes.string,
};
